export default "__VITE_ASSET__a3ab2461__"